<template lang="html">
  <v-container fill-height>
    <v-layout align-center justify-center>
      <div id="error-message"></div>
      <div id="card-errors"></div>
      <!-- <v-flex xs4 class="mx-4">
        <stripe-checkout
          ref="checkoutBasic"
          :pk="STRIPE_PUBLISHABLE_KEY"
          :items="firstItems"
          :customerEmail="currentUser.email"
        >
          <template slot="checkout-button">
            <v-hover>
              <v-card flat class="package-card package-card--basic"
                slot-scope="{ hover }"
                :class="`${hover ? 'package-card--hover' : ''}`"
              >
                <v-card-title class="title">
                  Sole-Proprietor
                </v-card-title>
                <v-card-text class="subheading my-4">
                  <div>Starts at $<span class="font-weight-bold">69/month</span></div>
                  <div>(Tax-deductible)</div>
                </v-card-text>
                <v-card-actions class="mt-4">
                  <v-btn
                    block
                    @click="checkoutBasic"
                    role="link"
                    class="elevation-0 subscribe-button subscribe-button--basic text-capitalize font-weight-bold"
                  >
                    Subscribe
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </template>
        </stripe-checkout>
      </v-flex> -->
      <!-- <v-flex xs3 class="mx-4">
        <stripe-checkout
          ref="checkoutAdvancedPartnership"
          :pk="STRIPE_PUBLISHABLE_KEY"
          :items="secondItems"
          :customerEmail="currentUser.email"
        >
          <template slot="checkout-button">
            <v-hover>
              <v-card flat class="package-card package-card--advanced-partnership"
                slot-scope="{ hover }"
                :class="`${hover ? 'package-card--hover' : ''}`"
              >
                <v-card-title class="title">
                  Tax Advanced Package (Partnership)
                </v-card-title>
                <v-card-text class="subheading my-4">
                  <div>Starts at $75/month</div>
                  <div>(Tax-deductible)</div>
                </v-card-text>
                <v-card-actions class="mt-4">
                  <v-btn
                    block
                    @click="checkoutAdvanced"
                    role="link"
                    class="elevation-0 subscribe-button subscribe-button--advanced-partnership text-capitalize font-weight-bold"
                  >
                    Subscribe
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </template>
        </stripe-checkout>
      </v-flex> -->
      <!-- <v-flex xs4 class="mx-4">
        <stripe-checkout
          ref="checkoutAdvanced"
          :pk="STRIPE_PUBLISHABLE_KEY"
          :items="thirdItems"
          :customerEmail="currentUser.email"
        >
          <template slot="checkout-button">
            <v-hover>
              <v-card flat class="package-card package-card--advanced"
                slot-scope="{ hover }"
                :class="`${hover ? 'package-card--hover' : ''}`"
              >
                <v-card-title class="title">
                  S-Corp, Partnership, C-Corp
                </v-card-title>
                <v-card-text class="subheading my-4">
                  <div>Starts at $<span class="font-weight-bold">129/month</span></div>
                </v-card-text>
                <v-card-actions class="mt-4">
                  <v-btn
                    block
                    @click="checkoutAdvanced"
                    role="link"
                    class="elevation-0 subscribe-button subscribe-button--advanced text-capitalize font-weight-bold"
                  >
                    Subscribe
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-hover>
          </template>
        </stripe-checkout>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>
<script>
// import { StripeCheckout } from 'vue-stripe-checkout';
import { firebase } from '@firebase/app';
import '@firebase/auth';
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  name: 'Payment',
  // components: {
  //   StripeCheckout,
  // },
  data: () => ({
    loading: false,
    STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY,
    firstItems: [
      {
        // plan: 'plan_FewQXk3T9RN7gc', //FOR TEST ONLY
        plan: 'price_1HS5JLLvDFqcfwR2dD2qneM9',
        quantity: 1,
      },
    ],
    // secondItems: [
    //   {
    //     plan: 'plan_GJPwSL96Cnp9PW',
    //     quantity: 1
    //   },
    // ],
    thirdItems: [
      {
        plan: 'price_1HS5IELvDFqcfwR2YG2JDTfE',
        quantity: 1,
      },
    ],
    // thirdItems: [
    //   {
    //     plan: 'plan_H6XiIbyHrx8QtO',
    //     quantity: 1
    //   },
    // ],
    successUrl: '/',
    cancelUrl: '/payment',
    submitType: null,
  }),
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },
  methods: {
    checkoutBasic() {
      this.$refs.checkoutBasic.redirectToCheckout();
    },
    checkoutAdvancedPartnership() {
      this.$refs.checkoutAdvancedPartnership.redirectToCheckout();
    },
    checkoutAdvanced() {
      this.$refs.checkoutAdvanced.redirectToCheckout();
    },
  },
  mounted() {
    if (this.currentUser.paying) {
      this.$router.push('/');
    }
  },
};
</script>

<style lang="postcss" scoped>
.package-card {
  padding: 15px;
  border-radius: 0px;
  box-shadow: 0 8px 32px #e7ebf6;
  &--basic {
  }
  &--advanced {
    color: white !important;
    background-color: #0081f6 !important;
  }
  &--advanced-partnership {
    background: linear-gradient(65deg, #ff9083 0, #ff6250 100%) !important;
    color: white !important;
  }
  &--hover {
    box-shadow: 0 25px 70px #0081f650;
  }
}
.subscribe-button {
  /* padding: 12px 16px; */
  border: 0;
  border-radius: 2px;

  &--basic {
    background: linear-gradient(65deg, #ff9083 0, #ff6250 100%) !important;
    color: white !important;
  }
  &--advanced {
    background: linear-gradient(65deg, #fff 0, #deefff 100%);
    color: #0081f6 !important;
  }
  &--advanced-partnership {
    background: linear-gradient(65deg, #fff 0, #deefff 100%);
    color: #0081f6 !important;
  }
}
</style>
